import styles from '../../assets/styles/Login/Login.module.scss';
import ForgotPasswordForm from './ForgotPasswordForm';
import LeftSide from '../pageComponents/LeftSide';
import React from 'react';

const ForgotPassword = ({
	validationSchema,
	onSubmit,
	loading,
	switchToLogin,
}) => {
	return (
		<div className={styles.container}>
			<LeftSide title="Welcome Back :)" />
			<div className={styles.rightside}>
				<div className={styles.logintext__center}>
					<h3 className={`${styles.logintext__title} ${styles.mb_30}`}>
						Forgot Password
					</h3>
				</div>
				<div className={styles.loginform}>
					<ForgotPasswordForm
						validationSchema={validationSchema}
						onSubmit={onSubmit}
						loading={loading}
					/>
				</div>
				<div className={`${styles.logintext__p} ${styles.mt_30}`}>
					Go back to{' '}
					<span className={styles.clickable} onClick={switchToLogin}>
						Login
					</span>
				</div>
			</div>
		</div>
	);
};

export default ForgotPassword;
